import React, { useContext, useState } from "react";
import DashboardCard, {
  DashboardContent,
  DashboardFooter,
  DashboardHeader,
} from "../../Common/DashboardCard";
import DashboardPage from "../../Common/DashboardPage";
import { AuthContext } from "../../../../Context/AuthContextProvider";
import { CustomFileInput } from "../../../../Assets/Elements";
import { MdDeleteForever } from "react-icons/md";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

function NewTicket() {
  const navigate = useNavigate();
  const { loginUser, raiseTicket } = useContext(AuthContext);
  const [mediaFiles, setMediaFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isResetLoading, setIsResetLoading] = useState(false);

  const handleFileChange = (files) => {
    setMediaFiles(files);
  };

  const removeImage = (index) => {
    const updatedFiles = mediaFiles.filter((_, i) => i !== index);
    setMediaFiles(updatedFiles);
  };

  const handle_input_change = (e) => {
    const { name, value } = e.target;

    set_form_data((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [form_data, set_form_data] = useState({
    generatorName: loginUser.username,
    generatorId: loginUser._id,
    title: "",
    description: "",
    attachments: [],
  });

  const handle_submit = async (e) => {
    e.preventDefault();

    // Basic form validation
    const { title, description } = form_data;
    if (!title || !description) {
      toast.error("Please fill in all the required fields.");
      return;
    }

    setIsLoading(true);
    try {
      const formData = new FormData();

      Object.keys(form_data).forEach((key) => {
        formData.append(key, form_data[key]);
      });

      mediaFiles.forEach((file) => {
        formData.append(`media`, file); // Change from `media_${index}` to `media`
      });

      const response = await raiseTicket(formData); // Assuming createProduct is an API call that accepts formData

      if (response && response.success) {
        set_form_data({
          generatorName: loginUser.username,
          generatorId: loginUser._id,
          title: "",
          description: "",
          attachments: [],
        });

        setMediaFiles([]); // Reset the media files
        navigate(`/dashboard/SingleTicket/${response.ticket._id}`);
      } else {
        toast.error("Failed to create product. Please try again."); // Handle the case when the response doesn't indicate success
      }
    } catch (error) {
      toast.error(`Failed to raise a ticket. ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handle_reset = async (e) => {
    e.preventDefault();
    setIsResetLoading(true);
    set_form_data({
      generatorName: loginUser.username,
      generatorId: loginUser._id,
      title: "",
      description: "",
      attachments: [],
    });
    setMediaFiles([]);
    setIsResetLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50/30 px-4 py-6 md:p-8">
      <div className="max-w-4xl mx-auto space-y-6">
        {/* ✅ Page Header */}
        <div className="flex items-center gap-3">
          <div className="p-3 bg-gradient-to-br from-[#b99653] to-[#d4af37] rounded-xl shadow-lg">
            <MdDeleteForever className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-gray-900">
              Raise a Support Ticket
            </h1>
            <p className="text-sm text-gray-600 mt-1">
              Submit an issue and our team will assist you as soon as possible
            </p>
          </div>
        </div>

        {/* ✅ Ticket Form Card */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
          {/* Header */}
          <div className="bg-gradient-to-r from-[#fcdb6a]/20 to-[#b99653]/10 px-6 py-4 border-b border-gray-200">
            <h2 className="text-xl font-bold text-gray-900">Ticket Details</h2>
          </div>

          {/* Form */}
          <div className="p-6 space-y-6">
            {/* Subject Field */}
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700">
                Subject
              </label>
              <input
                type="text"
                id="title"
                name="title"
                value={form_data.title}
                onChange={handle_input_change}
                placeholder="Write a short subject"
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#b99653] focus:ring-2 focus:ring-[#b99653]/20 transition-all outline-none text-gray-900 font-medium"
              />
            </div>

            {/* Message */}
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700">
                Message
              </label>
              <textarea
                id="description"
                name="description"
                value={form_data.description}
                onChange={handle_input_change}
                rows="4"
                placeholder="Describe your issue in detail"
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#b99653] focus:ring-2 focus:ring-[#b99653]/20 transition-all outline-none text-gray-900 font-medium"
              />
            </div>

            {/* Attachments */}
            <div className="space-y-4">
              <CustomFileInput
                label={
                  <div>
                    Attachments
                    <ul className="text-gray-500 ml-2 text-sm">
                      <li>Max 4 images</li>
                      <li>Max 200KB each</li>
                    </ul>
                  </div>
                }
                accept="image/*"
                multiple={true}
                onChange={handleFileChange}
              />

              {/* Selected Files Preview */}
              {mediaFiles.length > 0 && (
                <div className="bg-gray-50 p-4 border rounded-xl">
                  <h4 className="font-semibold text-gray-800">
                    Selected Files:
                  </h4>
                  <div className="flex gap-4 flex-wrap mt-3">
                    {mediaFiles.map((file, index) => (
                      <div className="relative" key={index}>
                        <img
                          src={URL.createObjectURL(file)}
                          alt={file.name}
                          className="w-28 h-28 rounded-xl object-cover shadow"
                        />
                        <button
                          className="absolute top-1 right-1 bg-white rounded-full shadow p-1 hover:bg-red-100"
                          onClick={() => removeImage(index)}
                        >
                          <MdDeleteForever className="text-red-600 text-xl" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* ✅ Action Buttons */}
          <div className="bg-gray-50 px-6 py-4 border-t flex flex-col sm:flex-row gap-3">
            <button
              className={`flex-1 px-6 py-3 rounded-xl font-semibold transition-all duration-200 ${
                isResetLoading
                  ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                  : "bg-white border-2 border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400"
              }`}
              onClick={handle_reset}
              disabled={isResetLoading}
            >
              {isResetLoading ? "Cancelling..." : "Cancel"}
            </button>

            <button
              className={`flex-1 px-6 py-3 rounded-xl font-semibold text-white transition-all duration-200 ${
                isLoading
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-gradient-to-r from-[#b99653] to-[#d4af37] hover:shadow-lg hover:scale-[1.02]"
              }`}
              onClick={handle_submit}
              disabled={isLoading}
            >
              {isLoading ? "Submitting..." : "Raise Ticket"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewTicket;
